import { TreeViewSettings } from "../../models/TreeViewSettings";

const treeViewConfigs = new Map<string, TreeViewSettings>([
    ["categories", { expanded: false, checked: false, hasChildren: false, children: [], text: "cat_descr_aff", checkId: "cat_cd", stats: [] }],
    ["departements", { expanded: false, checked: false, hasChildren: true, children: [], text: "dept_nom_aff", checkId: "dept_cd", stats: [] }],
    ["divisions", { expanded: false, checked: false, hasChildren: true, children: [], text: "div_nom_aff", checkId: "div_num", stats: [] }],
    ["fournisseurs", { expanded: false, checked: false, hasChildren: true, children: [], text: "four_nom_aff", checkId: "four_cd", stats: [] }],
    ["taches", { expanded: false, checked: false, hasChildren: false, children: [], text: "description", checkId: "id", stats: [] }],
    ["activites", { expanded: false, checked: false, hasChildren: false, children: [], text: "act_aff", checkId: "act_cd", stats: [] }]
]);

export const addTreeViewSettings = (apiResponse: any[], name: string) => {
    let treeViewSettings = treeViewConfigs.get(name)!;
    let updatedApiResponse = apiResponse.map(a => { return { ...a, ...treeViewSettings, text: a[treeViewSettings.text], checkId: a[treeViewSettings.checkId], stats: a.stats } })
    return updatedApiResponse;
}